<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un Tramite</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" value="value">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los Tramite</option>
        <option v-for="Tramite in Tramites" :value="Tramite.TramiteId" :key="Tramite.TramiteId">{{Tramite.Nombre}}</option>
      </select>
    </div>
  </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default
  {
    data(){
      return {
        enumeraciones,
        comun,
        Tramites:[],
        idDelModelo: null
      }
    },//Data
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object
    },//Props
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const params = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      this.$store.dispatch("A_PJ_Catalogo_Establecer046Tramite", params);
    },
    methods: {
      cargarCatalogoDeTramites(){
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        if(!this.parametros.JuicioId && this.$store.state.PJ_Catalogos_042Juicios.valor > 0) 
          this.parametros.JuicioId =  this.$store.state.PJ_Catalogos_042Juicios.valor;
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba;

        axios
        .post(api.conexion + api.PJ.catalogos.C046Tramites, this.parametros)
        .then(respuesta => {
          if (respuesta.data.SiHayError) {
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {
            this.Tramites = respuesta.data.Tramites;
            return respuesta.data.Tramites;
          }
        })
        .catch(e => {
          console.log("No Hay Respuesta del Servidor" + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
        });
      },//CargarCatalogoDeTramites
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const params = {
          llave: this.idDelInput,
          valor: evento.target.value
        }

        this.$store.dispatch("A_PJ_Catalogo_Establecer046Tramite", params);
        this.$emit("valorParaElPadre", evento);
      }
    },//Methods
    created() {
      this.cargarCatalogoDeTramites();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PJ/Catalogos/046Tramites.vue